import React from "react"
import { Box, Flex, Text, Button, SimpleGrid } from "@chakra-ui/react"
import type { VariantType } from "@shared/graphql.types"
import { space } from "theme/themeConfig"
import { useLocale } from "hooks"
import { getPDPUrl } from "utils/getPDPUrl"
import { Link } from "components/Link"
import { Separator } from "./CoreProductInfo.style"
import { colours } from "@shared/ui.design-system"

interface Props {
  variant: VariantType
}

export const TextileSizes: React.FC<Props> = ({ variant }) => {
  const locale = useLocale()

  const relatedVariants = (variant.relatedVariants ?? []).filter(
    (v) => v?.id !== variant.id
  )

  if (!relatedVariants.length) return null

  const hasLifestyleAsPrimaryCategory = variant.categoryName === "Lifestyle"

  const sizes: any = [variant, ...(relatedVariants || [])].sort((a, b) =>
    (a?.size ?? "").localeCompare(b?.size ?? "", undefined, { numeric: true })
  )

  const viewSizeGuide = () => {
    // Desktop
    const tabs = document.querySelector("#pdpTabs")
    const tabButton: any = document.querySelector("#sizeTab")
    tabButton?.click()
    tabs?.scrollIntoView({ behavior: "smooth" })

    // Mobile
    const accordionHeader: any = document.querySelector("#sizeAccordion")
    const accordionButton: any = accordionHeader.querySelectorAll(
      "[aria-expanded='false']"
    )
    if (accordionButton?.length > 0) {
      accordionButton[0]?.click()
    }
    accordionHeader?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <>
      <Box pb={-1}>
        <Flex alignItems="center" justifyContent="space-between" mb={1}>
          <Text variant="acuminLight" m={0}>
            Choose a size
          </Text>
          {hasLifestyleAsPrimaryCategory && (
            <Button
              onClick={viewSizeGuide}
              m={0}
              variant="transparent"
              height="auto"
            >
              <Text variant="acuminLight" m={0} textDecoration="underline">
                View size guide
              </Text>
            </Button>
          )}
        </Flex>

        <SimpleGrid columns={{ base: 4, md: 5 }} spacing={{ base: -1, md: 1 }}>
          {sizes?.map((shade) => {
            const isSelected = variant.id === shade?.id
            const outOfStock = shade?.availability?.status === "outofstock"

            return (
              <Link
                href={getPDPUrl(shade, locale)}
                key={shade?.id ?? ""}
                width="100%"
              >
                <Flex
                  alignItems="center"
                  justify="center"
                  border={`1px solid ${colours.secondary.deep}`}
                  bgColor={isSelected ? colours.accent.soft : "transparent"}
                  height="60px"
                  opacity={outOfStock ? 0.5 : 1}
                  cursor="pointer"
                >
                  <Text variant="caps1" m={0}>
                    {shade?.size}
                  </Text>
                </Flex>
              </Link>
            )
          })}
        </SimpleGrid>
      </Box>

      <Separator mb={`${space["1"]} !important`} />
    </>
  )
}
